import React from 'react'

import { TextModule } from './TextModules'

export default class BatchJobNameModule extends TextModule {

  constructor(props) {
    super(props, 10)
  }

  getLabelText() {
    return 'Jobs'
  }

  getPlaceholder() {
    return 'List jobs one per line \neg.\nLot 1 - Hardware\nLot 2 - Hardware\nLot 3 - Hardware'
  }

  getModulePath() {
    return '/modules/batchName/value'
  }

  getModuleInfo() {
    return this.state.jobInfo.modules.batchName.value
  }

  render() {
    return super.render(this)
  }

}



// WEBPACK FOOTER //
// ./src/schedule/common/modules/text/BatchJobNameModule.js